import React from "react";
import { Formik } from "formik";
import { ContactPageValidation } from "./validation";
import { Grid, Paper, Typography } from "@mui/material";
import Button from "../../Common/Button";
import { useDispatch } from "react-redux";
import { setSnackBar } from "../../../store/common/commonSlice";
import Input from "../../Common/Input";
import { useUpdateContactPageCMSMutation } from "../../../store/cms/cmsApis";
import { CommonPdfFileUploadToServer } from "../../Common/CommonPdfFileUploadToServer";

export const ContactPageCmsForm = ({ contactInitialValues, sansthaId }) => {
    const dispatch = useDispatch();
    const [updateContactPage] = useUpdateContactPageCMSMutation();

    const onFormSubmit = async (values) => {
        try {
            let payload = { ...values };
            delete payload.createdAt;
            delete payload.updatedAt;
            payload.sanstha_id = sansthaId;
            await updateContactPage(payload).unwrap();
            dispatch(setSnackBar({
                open: true,
                message: "Data updated successfully",
                severity: "success",
            }))
        } catch (error) {
            dispatch(setSnackBar({
                open: true,
                message: error?.data?.message || error.message,
                severity: "error",
            }))
        }
    };

    return (
        <Formik
            initialValues={contactInitialValues}
            onSubmit={(values) => onFormSubmit(values)}
            validationSchema={ContactPageValidation}
            enableReinitialize
        >
            {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                errors,
                setFieldValue
            }) => (
                <Paper
                    sx={{ p: 2, color: "#071B2A", fontWeight: "400" }}
                    elevation={0}
                >
                    <Grid sx={{ display: "flex" }} direction={"column"} width={"100%"} height={"100%"} >
                        <Grid flex={1} px={2} py={5} overflow={"auto"}>
                            <Grid container spacing={2} >
                                <Grid item xs={12} md={12}>
                                    <Typography variant="h6">Home Contact Us CMS</Typography>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Input
                                        id='address'
                                        name="address"
                                        label="Address"
                                        onChange={handleChange("address")}
                                        value={values?.address || ""}
                                        error={Boolean(errors?.address)}
                                        helperText={errors?.address}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Input
                                        id='email_1'
                                        name="email_1"
                                        label="Primary Email Address"
                                        onChange={handleChange("email_1")}
                                        value={values?.email_1 || ""}
                                        error={Boolean(errors.email_1)}
                                        helperText={errors.email_1}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Input
                                        id='email_2'
                                        name="email_2"
                                        label="Secondary Email Address"
                                        onChange={handleChange("email_2")}
                                        value={values?.email_2 || ""}
                                        error={Boolean(errors.email_2)}
                                        helperText={errors.email_2}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Input
                                        id='phone_1'
                                        name="phone_1"
                                        label="Primary Phone Number"
                                        onChange={handleChange("phone_1")}
                                        value={values?.phone_1 || ""}
                                        error={Boolean(errors.phone_1)}
                                        helperText={errors.phone_1}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Input
                                        id='phone_2'
                                        name="phone_2"
                                        label="Secondary Phone Number"
                                        onChange={handleChange("phone_2")}
                                        value={values?.phone_2 || ""}
                                        error={Boolean(errors.phone_2)}
                                        helperText={errors.phone_2}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid flex={1} px={2} py={5} overflow={"auto"}>
                            <Grid container spacing={2} >
                                <Grid item xs={12} md={12}>
                                    <Typography variant="h6">Offline Form</Typography>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <CommonPdfFileUploadToServer
                                        name="offline_form"
                                        onChange={(val) => setFieldValue("offline_form", val)}
                                        value={values?.offline_form || ""}
                                        label="Offline Form"
                                        error={Boolean(errors.offline_form)}
                                        helperText={errors.offline_form}
                                        labelSecondary="Upload offline form"
                                        types={["pdf"]}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid flexShrink={0} borderTop={1} borderColor={"rgba(152, 188, 252, 0.16)"} sx={{ padding: "8px 16px" }}>
                            <Grid sx={{ display: "flex", justifyContent: "flex-end" }}>
                                <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Button size="large" type="submit" loading={false} onClick={() => handleSubmit()}>Save</Button>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Paper>
            )
            }
        </Formik >
    )
}